export default __webpack_public_path__ + "static/media/79.fff4f537.png";